import dosingBlockFragment from "@groq/fragments/pageBlock";

const dosingBlockQuery = `*[_type == "dosingBlock"]| order(title asc)
${dosingBlockFragment}
`;

export default dosingBlockQuery;
